import { RequestCouponForPEPResponse } from "../../../api";
import { CouponType, DeviceType } from "../types";

export const CREATE_COUPON_FOR_PEP_REQUEST = "@@Coupons/CREATE_COUPON_FOR_PEP_REQUEST" as const;
export const CREATE_COUPON_FOR_PEP_SUCCESS = "@@Coupons/CREATE_COUPON_FOR_PEP_SUCCESS" as const;
export const CREATE_COUPON_FOR_PEP_FAILED = "@@Coupons/CREATE_COUPON_FOR_PEP_FAILED" as const;

export type CreateCouponForPepRequestPayload = {
  callId: string;
  couponType: CouponType;
  deviceType: DeviceType;
};

export const createCouponForPepRequest = (payload: CreateCouponForPepRequestPayload) =>
  ({
    type: CREATE_COUPON_FOR_PEP_REQUEST,
    payload,
  } as const);

export const createCouponForPepSuccess = (payload: RequestCouponForPEPResponse) =>
  ({
    type: CREATE_COUPON_FOR_PEP_SUCCESS,
    payload,
  } as const);

export const createCouponForPepFailed = (payload: any) =>
  ({
    type: CREATE_COUPON_FOR_PEP_FAILED,
    payload,
  } as const);

export type CreateCouponForPepAction = ReturnType<typeof createCouponForPepRequest>;

export type CouponsAction =
  | CreateCouponForPepAction
  | ReturnType<typeof createCouponForPepSuccess>
  | ReturnType<typeof createCouponForPepFailed>;
